import $http from '../http/index'
import {BrandDecoration} from '../Entity/BrandDecoration'

interface LanguageInfo{
    CN:string,
    EN:string
}

const allLanguages:Array<LanguageInfo>=[];

class Helper{
    /**
     * 生成唯一键
     */
    createID(){
        return Date.now() + "_" + Math.random().toString(36);
    }

    /**
     * 文件分片上传
     * @param file 上传的文件
     * @param handleType 上传文件的处理类型（C#类名）
     * @param handleParam 处理参数（不需要携带处理参数时可以传入空字符串即可）
     * @param finishedCallBack 文件上传完成时的回调函数
     * @returns 无
     */
    fileUpload(file: File, handleType:string,handleParam:string,finishedCallBack:  (result: string) => void ){
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);////将文件读取为 DataURL,也就是base64编码
        reader.onload = function () { //文件读取成功完成时触发
            const fileContent = reader.result; //获得文件读取成功后的DataURL,也就是base64编码
            if(fileContent==null)return;
            const fileContentStr = fileContent.toString()
            // 每个文件切片大小定为256K .
            const bytesPerPiece = 1024 * 256 ;
            //计算文件切片总数
            const totalPieces = Math.ceil(fileContentStr.length / bytesPerPiece);
            if (totalPieces == 0) { //空文件
                return;
            }
            const fileContents:Array<string> = []
            for(let currentPiece = 1;currentPiece<=totalPieces;currentPiece++){
                const startIndex = (currentPiece - 1) * bytesPerPiece;
                const getLength = currentPiece * bytesPerPiece > fileContentStr.length ? fileContentStr.length - startIndex : bytesPerPiece;
                fileContents.push(fileContentStr.slice(startIndex,startIndex+getLength));
            }
            const fileContentKeys:Array<string> = []
            const fileID = $helper.createID();
            for(let index=0;index<fileContents.length;index++){
                const dto = {
                    FileID:fileID,
                    CurrentPiece:index,
                    FileContent:fileContents[index]
                }
                $http({
                    url: "/API/Product/FileContentUpload",
                    method: "POST",
                    data: {
                        dto: JSON.stringify(dto)
                    },
                    }).then(res => {
                    fileContentKeys.push(res.data);
                    // 文件分片已经全部上传完成，即将处理文件
                    if(fileContentKeys.length==fileContents.length){
                        $http({
                        url: "/API/Product/HandleFilePieceUpload",
                        method: "POST",
                        data: {
                            handleType: handleType,//"ImageParseVin",
                            handleParam: handleParam,//"",
                            keys: JSON.stringify(fileContentKeys),
                            fileName: file.name
                        },
                        }).then(res => {
                            finishedCallBack(res.data);
                        })
                    }
                })
            }
        }
    }

    /**
     * 数字格式转换成千分位
     * @param num 
     * @returns 
     */
    commafy(num:any){
        const defaultValue = "0";
        if(num==null || isNaN(num)){
            return defaultValue;
        }
        let inputValue = `${num}`;
        if (/^.*\..*$/.test(inputValue)) {
            const pointIndex = inputValue.lastIndexOf(".");
            let intPart = inputValue.substring(0, pointIndex);
            const pointPart = inputValue.substring(pointIndex + 1, inputValue.length);
            intPart = intPart + "";
            const re = /(-?\d+)(\d{3})/
            while (re.test(intPart)) {
                intPart = intPart.replace(re, "$1,$2")
            }
            inputValue = intPart + "." + pointPart;
        } else {
            inputValue = inputValue + "";
            const re = /(-?\d+)(\d{3})/
            while (re.test(inputValue)) {
                inputValue = inputValue.replace(re, "$1,$2")
            }
        }
        return inputValue;
    }

    /**
     * 是否有权限
     * @param code 权限编码
     * @returns 结果。true:有权限 false：无权限
     */
    hasPermission(code:string){
        const permissionCodesStr = window.localStorage.getItem("PermissionCodes");
        if(permissionCodesStr){
            const codes:Array<string> = JSON.parse(permissionCodesStr);
            if(codes.indexOf(code)>-1)
            return true;
        }
        //debugger
        return false;
    }

    /**
     * 获取权限编码
     * @param callBack 
     */
    getPermissionCodes(){
        const permissionCodesStr = window.localStorage.getItem("PermissionCodes");
        if(permissionCodesStr){
            return JSON.parse(permissionCodesStr);
        }
        //debugger
        return [];
        // const userInfoJson = window.localStorage.getItem("userInfo");
        // let userID = "";
        // if(userInfoJson){
        //     userID = JSON.parse(userInfoJson).ID;
        // }
        // $http({
        //     url: "API/FrontEndUser/GetPermissionCodes",
        //     method: "POST",
        //     data: {
        //         userID: userID
        // },
        // }).then(res => {
        //     callBack(res.data);
        //     window.localStorage.setItem("PermissionCodes",JSON.stringify(res.data));
        // })
    }

    /**
     * 获取用户的品牌信息
     * @returns 品牌数组
     */
    getUserBrands(){
        const userInfoJson = window.localStorage.getItem("userInfo");
        let brands:Array<string> = [];
        if(!userInfoJson){
            return brands;
        }
        else{
            brands=JSON.parse(userInfoJson).Brand.split(',');
        }
        return brands;
    }

    // 多语言转换
    lan(cnContent:string|null|undefined){
        if(!cnContent){
            return '';
        }
        const lanType = window.localStorage.getItem('lanType');
        if(!lanType || lanType=='CN'){
            return cnContent;
        }
        if(allLanguages.length<1){
            const lanJson = window.localStorage.getItem("lan");
            if(lanJson){
                const lans = JSON.parse(lanJson);
                for(let i=0;i<lans.length;i++){
                    allLanguages.push(lans[i])
                }
            }
        }
        for(let i=0;i<allLanguages.length;i++){
            const lan = allLanguages[i];
            if(lan.CN == cnContent){
                return lan.EN;
            }
        }
        return cnContent;
    }

    /**
     * 将2014年1月 转成 01/2024
     * @param inputDate 
     * @returns 
     */
    convertDate(inputDate:string) { 
        if(!inputDate){
            return '';
        } 
        let inputStr = inputDate.replace('年','-');
        inputStr = inputStr.replace('月','');
        const yearMonth = inputStr.split('-');
        if(yearMonth.length!=2){
            return '';
        }
        if(yearMonth[1].length<2){
            return `0${yearMonth[1]}/${yearMonth[0]}`;
        }
        return `${yearMonth[1]}/${yearMonth[0]}`;
    }
    
    /**
     * 打开新页面
     * @param path 
     */
    openNewPage(path:string){
        const currentProtocol = window.location.protocol
        const host = window.location.host;
        const url = `${currentProtocol}//${host}/#${path}`
        window.open(url)
    }

    /**获取平铺装修基本信息 */
    getBrandDecoration():BrandDecoration{
        const decoration:BrandDecoration={
            PageTitleCN:'',
            PageTitleEN:'',
            DomainName:'',
            DomainNameIcon:'',
            BrandDatas:'',
            BrandName:'glory',
            MainBackColor:'000000',
            BarColor:'',
            BrandInputColor:'',
            BrandPictureCN:'',
            HasBrandPictureCN:'',
            BrandPictureEN:'',
            HasBrandPictureEN:'',
            BrandAdCN:'',
            HasBrandAdCN:'',
            BrandAdEN:'',
            HasBrandAdEN:'',
            ShowBrandPicture:'',
            ShowBrandAd:'',
            CarTypes:'',
            ProductTypes:'',
            FontColor:''
        }
        const decorationStr = window.localStorage.getItem("brandDecorations");
        if(!decorationStr){
            return decoration;
        }
        const decorations:Array<BrandDecoration> = JSON.parse(decorationStr);
        const domainName = window.localStorage.getItem("domainName");
        if(!domainName || !decorations ){
            return decoration;
        }
        const index = decorations.findIndex(c=>c.DomainName.toLowerCase()==domainName.toLowerCase());
        if(index<0){
            return decoration;
        }
        decoration.PageTitleCN = decorations[index].PageTitleCN;
        decoration.PageTitleEN = decorations[index].PageTitleEN;
        decoration.DomainName = decorations[index].DomainName;
        decoration.DomainNameIcon = decorations[index].DomainNameIcon;
        decoration.BrandDatas = decorations[index].BrandDatas;
        decoration.BrandName = decorations[index].BrandName;
        decoration.MainBackColor = decorations[index].MainBackColor;
        decoration.BarColor = decorations[index].BarColor;
        decoration.BrandInputColor = decorations[index].BrandInputColor;
        decoration.BrandPictureCN = decorations[index].BrandPictureCN;
        decoration.HasBrandPictureCN = decorations[index].HasBrandPictureCN;
        decoration.BrandPictureEN = decorations[index].BrandPictureEN;
        decoration.HasBrandPictureEN = decorations[index].HasBrandPictureEN;
        decoration.BrandAdCN = decorations[index].BrandAdCN;
        decoration.HasBrandAdCN = decorations[index].HasBrandAdCN;
        decoration.BrandAdEN = decorations[index].BrandAdEN;
        decoration.HasBrandAdEN = decorations[index].HasBrandAdEN;
        decoration.CarTypes = decorations[index].CarTypes;
        decoration.ProductTypes = decorations[index].ProductTypes;
        decoration.FontColor = decorations[index].FontColor;
        
        let lanType = window.localStorage.getItem('lanType');
        if(!lanType){
            lanType="CN"; //默认CN
        }
        if(lanType=="CN" && decoration.HasBrandPictureCN=='T'){
            decoration.ShowBrandPicture = decoration.BrandPictureCN
        }
        else if(lanType=="EN" && decoration.HasBrandPictureEN=='T'){
            decoration.ShowBrandPicture = decoration.BrandPictureEN
        }else if(decoration.HasBrandPictureCN=='T'){
            decoration.ShowBrandPicture = decoration.BrandPictureCN
        }

        if(lanType=="CN" && decoration.HasBrandAdCN=='T'){
            decoration.ShowBrandAd = decoration.BrandAdCN
        }
        else if(lanType=="EN" && decoration.HasBrandAdEN=='T'){
            decoration.ShowBrandAd = decoration.BrandAdEN
        }else if(decoration.HasBrandAdCN=='T'){
            decoration.ShowBrandAd = decoration.BrandAdCN
        }
        //设置域名图标缓存
        window.localStorage.setItem("domainNameIcon",decoration.DomainNameIcon);
        window.localStorage.setItem("pageTitle",decoration.PageTitleCN);
        if(lanType=="EN"){
            window.localStorage.setItem("pageTitle",decoration.PageTitleEN);
        }
        return decoration;
    }

    /**
     * 
     * @returns 获取域名
     */
    getDomainName():string{
        let domainName = window.localStorage.getItem("domainName");
        if(!domainName){
            domainName = '';
        }
        return domainName;
    }
}


const $helper = new Helper()

export default $helper